"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbMessageModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _shapes = require("../../skybase-core/shapes");

var _sbButton = require("../sb-button/sb-button");

var _sbModal = require("../sb-modal");

var _actions = require("../../skybase-core/base/actions");

var _locales = require("../../skybase-core/locales");

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-components.sb-message-modal
 */

/**
 * @namespace skybase-components.sb-message-modal.sb-message-modal
 */
var handleOverlayClick = function handleOverlayClick(dispatch) {
  return dispatch((0, _actions.closeModal)());
};
/**
 * @typedef skybase-components.sb-message-modal.sb-message-modal#props
 *
 * @property {String} Title
 * @property {String} message
 * @property {Function} dispatch
 */

/**
 *
 * @name skybase-components.sb-message-modal.sb-message-modal#SbMessageModal
 * @function
 *
 * @param {skybase-components.sb-message-modal#props} props
 * @return {React.Component}
 */
// eslint-disable-next-line


var _SbMessageModal = function _SbMessageModal(props) {
  var className = props.className,
      closeButtonId = props.closeButtonId,
      closeButtonClassName = props.closeButtonClassName,
      id = props.id,
      title = props.title,
      message = props.message,
      dispatch = props.dispatch,
      onClickOverlay = props.onClickOverlay,
      _ = props.intl.formatMessage,
      style = props.style,
      width = props.width,
      height = props.height;
  var buttons = props.buttons,
      type = props.type;
  type = type || _constants.modalType.NOTICE; // by default there is just Ok button displayed, if no buttons prop were passed.

  buttons = buttons || [{
    position: 'right',
    title: 'Close',
    action: _actions.closeModal,
    id: closeButtonId,
    className: closeButtonClassName
  }];

  var handleButtonOnClick = function handleButtonOnClick(button) {
    var action = button.action;

    if (action) {
      dispatch(action());
    }
  };

  var handleOnClickOverlay = function handleOnClickOverlay() {
    onClickOverlay(dispatch);
  };

  var renderButtons = function renderButtons(buttonList, position) {
    return (0, _filter.default)(buttonList, function (button) {
      return button.position === position;
    }).map(function (button) {
      var buttonClassName = button.className,
          buttonId = button.id,
          buttonTitle = button.title,
          buttonPosition = button.position;
      var translatedButtonTitle = (0, _locales.translateMessage)(_, buttonTitle);
      return /*#__PURE__*/_react.default.createElement(_sbButton.SbButton, {
        id: buttonId,
        key: "".concat(translatedButtonTitle, "_").concat(buttonPosition),
        className: (0, _classnames.default)('sb-btn', buttonClassName),
        onClick: function onClick() {
          handleButtonOnClick(button);
        }
      }, translatedButtonTitle);
    });
  };

  var Header = /*#__PURE__*/_react.default.createElement(_sbModal.SbModalHeader, {
    title: (0, _locales.translateMessage)(_, title),
    closeEnabled: false,
    id: "sb-message-modal-header"
  });

  var Footer = /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-footer fl-container fl-justify-end"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-left"
  }, renderButtons(buttons, 'left')), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-center"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-right"
  }, renderButtons(buttons, 'right')));

  var iconClassName = (0, _utils.getIconClass)(type);
  return /*#__PURE__*/_react.default.createElement(_sbModal.SbModal, {
    onClickOverlay: handleOnClickOverlay,
    Header: Header,
    Footer: Footer,
    width: width,
    height: height,
    id: id,
    style: style,
    className: (0, _classnames.default)('sb-message-modal', type, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-message-modal-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-message-icon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(iconClassName)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-message-text"
  }, (0, _locales.translateMessage)(_, message))));
};

_SbMessageModal.propTypes = {
  className: _propTypes.default.string,
  closeButtonClassName: _propTypes.default.string,
  closeButtonId: _propTypes.default.string,
  id: _propTypes.default.string,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    position: _propTypes.default.oneOf(['left', 'right', 'center']),
    title: _propTypes.default.string,
    action: _propTypes.default.func,
    id: _propTypes.default.string,
    className: _propTypes.default.string
  })),
  dispatch: _propTypes.default.func.isRequired,
  message: _propTypes.default.oneOfType([_propTypes.default.node, _locales.messageShape]),
  style: _propTypes.default.object,
  // eslint-disable-line
  title: _propTypes.default.oneOfType([_propTypes.default.node, _locales.messageShape]),
  type: _propTypes.default.string,
  intl: _shapes.intlShape.isRequired,
  onClickOverlay: _propTypes.default.func,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
_SbMessageModal.defaultProps = {
  className: null,
  closeButtonClassName: null,
  closeButtonId: null,
  id: null,
  buttons: null,
  message: '',
  style: null,
  title: '',
  type: '',
  width: 600,
  height: 'auto',
  onClickOverlay: function onClickOverlay(dispatch) {
    return handleOverlayClick(dispatch);
  }
};
var SbMessageModal = (0, _reactIntl.injectIntl)(_SbMessageModal);
exports.SbMessageModal = SbMessageModal;
//# sourceMappingURL=sb-message-modal.js.map